let BASE_URL = process.env.REACT_APP_PHISHING_URL;
let COMPONENT_URL = process.env.REACT_APP_COMPONENT_URL;

if (!BASE_URL || !COMPONENT_URL) {
    const urlhost = window.location.host;
    type Env = "dev" | "stg" | "prod";
    let ENV : Env = "prod";
    if (urlhost.includes("ev.") || urlhost.includes("localhost")) ENV = "dev";
    if (urlhost.includes("tg.")) ENV = "stg";

    const BASE_URLS = {
        dev: "https://api.phishing-manager.dev.venzagrc.com",
        stg: "https://api.phishing-manager.stg.venzagrc.com",
        prod: "https://api.phishing-manager.venzagrc.com"
    };
    
    const COMPONENT_URLS = {
        dev: "https://components.dev.venzagrc.com/venza",
        stg: "https://components.stg.venzapeak.com/venza",
        prod: "https://components.venzapeak.com/venza"
    };
    
    if (!BASE_URL) BASE_URL = BASE_URLS[ENV];
    if (!COMPONENT_URL) COMPONENT_URL = COMPONENT_URLS[ENV];
}

const API_URL = `${BASE_URL}/public`;
export const PDF_URL = `${COMPONENT_URL}/pdfs`;

const ROUTES: Record<string, string> = {
	CAMPAIGN_API: `${API_URL}/campaigns`,
    CAMPAIGN_SUMBIT_STEP_1: `${API_URL}/campaigns/create/step-1`,
    CAMPAIGN_SUMBIT_STEP_2: `${API_URL}/campaigns/create/step-2`,
    CAMPAIGN_SUMBIT_STEP_3: `${API_URL}/campaigns/create/step-3`,
    CAMPAIGN_SUMBIT_STEP_4: `${API_URL}/campaigns/create/step-4`,
    LAUNCH_CAMPAIGN: `${API_URL}/campaigns/create/start-test`,
    TENANT_API: `${API_URL}/tenants`,
    TENANT_USERS_API: `${API_URL}/tenants/users-count`,
    TENANT_THRESHOLD_SUFFIX: `campaigns/threshold-summary`,
    TEMPLATE_API: `${API_URL}/packaged-templates`,
    TEMPLATE_PREVIEW: `${API_URL}/packaged-templates/preview`,
    TEMPLATE_FILTER_API: `${API_URL}/packaged-templates/filters`,
    TIMEZONE_API: `${API_URL}/timezones`,
    RE_RUN_CAMPAIGN: `${API_URL}/campaigns/create/rerun-test`,
    PROPERTIES_API: `${API_URL}/tenants/properties`,
    GROUP_API: `${API_URL}/tenants/property/groups`,
    ROLES_API: `${API_URL}/tenants/property/roles`,
    INDIVIDUAL_API: `${API_URL}/tenants/groups/users`,
    REPORT_OVERALL_API: `${API_URL}/campaigns/analytics`,
    CORE_METRICS_API: `${API_URL}/campaigns/core-metrics`,
    PROPERTIES_METRICS_API: `${API_URL}/campaigns/property-metrics`,
    REPORTS_FILTERS: `${API_URL}/campaigns/report-filters`
}

export default ROUTES